import mapProps from '../scripts/utils/map-props';
import Checkbox from './checkbox';

export default mapProps(
  [
    'checked',
  ],
  {
    model: {
      prop: 'checked',
      event: 'change',
    },
  }
)(Checkbox);
